import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CowingCoreService {
    public appVersion = '';
    public menuOptions = [];
    static instance: CowingCoreService = new CowingCoreService();

    constructor() {
        return (CowingCoreService.instance = CowingCoreService.instance || this);
    }

    setAppVersion(appVersion: string) {
        this.appVersion = appVersion;
    }

    getAppVersion() {
        return this.appVersion;
    }

    setNavMenuOptions(options) {
        console.log('MENU OPTIONS SET', options);
        this.menuOptions = options;
    }

    getNavMenuOptions() {
        return this.menuOptions;
    }
}
